import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { Login } from "./Login";
import { SubscriptionPicker } from "./SubscriptionPicker";
import { Messages } from "./Messages";
import { AderantLogo } from "./AderantLogo";
/**
 * Component displaying a Login Page.
 */
export function LoginPage(props) {
    const { appName, appDescription, appLogo, appColor, loginPrompt, subscriptions, styles, onSignIn, onSelectSubscription, errorMessage, setErrorMessage, isAcquiringToken, isLoggedIn, isAppLoading } = props;
    const appBackgroundContainerName = appName + " Application";
    const loginPageId = props.id ?? appBackgroundContainerName.replaceAll(" ", "-");
    const [loginHint, setLoginHint] = useState(isLoggedIn ? props.loginHint : "");
    const [showLoginId, setShowLoginId] = useState(errorMessage || subscriptions.length === 0 || (!isLoggedIn && !loginHint));
    const [selectedSubscription, setSelectedSubscription] = useState(props.selectedSubscription ?? (isLoggedIn && !errorMessage && subscriptions.length == 1 ? subscriptions[0] : ""));
    const [showSubscriptionPicker, setShowSubscriptionPicker] = useState(isLoggedIn && subscriptions.length > 1 && selectedSubscription.length == 0);
    const handleSignIn = (loginId) => {
        if (loginId && loginId !== loginHint) {
            setLoginHint(loginId);
            onSignIn(loginId);
        }
    };
    useEffect(() => {
        if (isLoggedIn && subscriptions.length === 0 && !errorMessage) {
            //If a user logs in and Identity returns no subscriptions for the app, the user is not authorised for any subscriptions - set error message
            setErrorMessage(Messages.LOGIN_UNAUTHORIZED_ERROR.getMessage([appName]));
        }
    }, [isLoggedIn, subscriptions, errorMessage, setErrorMessage, appName]);
    if (!isLoggedIn && props.loginHint) {
        //If we've been given a login hint, - auto sign in
        handleSignIn(props.loginHint);
    }
    useEffect(() => {
        if (errorMessage) {
            setShowLoginId(true);
        }
        else if (isLoggedIn || loginHint) {
            setShowLoginId(false);
        }
    }, [loginHint, isLoggedIn, errorMessage]);
    const handleSelectSubscription = (subscription) => {
        if (subscription && subscription !== selectedSubscription) {
            setSelectedSubscription(subscription);
        }
    };
    useEffect(() => {
        //Don't show the subscription picker or select a subscription if we have an errorMessage - we need to show the login form with the error message
        if (!errorMessage) {
            if (!isLoggedIn) {
                setShowSubscriptionPicker(false);
            }
            else {
                if (selectedSubscription) {
                    setShowSubscriptionPicker(false);
                    onSelectSubscription(selectedSubscription);
                }
                else {
                    if (subscriptions.length === 1) {
                        setSelectedSubscription(subscriptions[0]);
                        setShowSubscriptionPicker(false);
                    }
                    else {
                        setShowSubscriptionPicker(true);
                    }
                }
            }
        }
    }, [selectedSubscription, isLoggedIn, subscriptions, errorMessage]);
    const defaultStyles = {
        appBackgroundContainer: {},
        appAccentContainer: {
            backgroundColor: appColor ?? "transparent"
        },
        loginStyles: {},
        subscriptionPickerStyles: {}
    };
    const combinedStyles = styles ? { ...defaultStyles, ...styles } : defaultStyles;
    if (!isAppLoading && isLoggedIn && selectedSubscription.length > 0) {
        //No login required - we're already logged in and have a subscription
        return React.createElement(React.Fragment, null);
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap", rel: "stylesheet" }),
            React.createElement("div", { id: loginPageId, "aria-label": appBackgroundContainerName, className: "aderant-application", style: combinedStyles.appBackgroundContainer },
                React.createElement("div", { className: "aderant-application-container" },
                    React.createElement("div", { className: "aderant-application-details" },
                        appLogo,
                        React.createElement("p", { "aria-label": "Application Description" }, appDescription)),
                    React.createElement("div", null, isAcquiringToken || isAppLoading ? (React.createElement("div", { "aria-label": "Loading Spinner Container", className: "loading-spinner-container" },
                        React.createElement(CircularProgress, { "aria-label": "Loading Spinner" }))) : (React.createElement(React.Fragment, null, showLoginId ? (React.createElement("div", { id: `${appBackgroundContainerName}-accent`, "aria-label": `${appBackgroundContainerName} Accent`, className: "aderant-login-accent", style: combinedStyles.appAccentContainer },
                        React.createElement(Login, { appName: appName, loginHint: loginHint, loginPrompt: loginPrompt, onSignIn: handleSignIn, errorMessage: errorMessage, styles: combinedStyles.loginStyles }))) : showSubscriptionPicker ? (React.createElement("div", { id: `${appBackgroundContainerName}-accent`, "aria-label": `${appBackgroundContainerName} Accent`, className: "aderant-login-accent", style: combinedStyles.appAccentContainer },
                        React.createElement(SubscriptionPicker, { appName: appName, subscriptions: subscriptions, selectedSubscription: selectedSubscription, onSelectSubscription: handleSelectSubscription, styles: combinedStyles.subscriptionPickerStyles }))) : (React.createElement(React.Fragment, null)))))),
                React.createElement("div", { "aria-label": "Aderant Logo", className: "aderant-logo" }, AderantLogo))));
    }
}
